// extracted by mini-css-extract-plugin
module.exports = {"SettingItemContainer":"SettingItem_SettingItemContainer__22z51","Left":"SettingItem_Left__i98gm"};